import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import { RANGES } from '../model/filters';

type Props = { value: string; onChange: (range: string) => void };

export function TimeRangeTabs({ value, onChange }: Props) {
  return (
    <Stack direction="row" role="group" aria-label="Published within" sx={{ p: 0.375, gap: 0.25, borderRadius: 1.25, bgcolor: 'surface.sunken' }}>
      {RANGES.map((r) => {
        const isOn = r.value === value;
        return (
          <ButtonBase key={r.label} aria-pressed={isOn} onClick={() => { onChange(r.value); }} sx={tabSx(isOn)}>
            {r.label}
          </ButtonBase>
        );
      })}
    </Stack>
  );
}

const tabSx = (isOn: boolean) => ({
  height: 26,
  px: 1.25,
  borderRadius: 1,
  fontSize: '0.75rem',
  fontWeight: isOn ? 600 : 500,
  color: isOn ? 'text.primary' : 'text.secondary',
  bgcolor: isOn ? 'background.paper' : 'transparent',
  boxShadow: isOn ? '0 1px 2px rgba(26, 26, 25, 0.08)' : 'none',
  transition: 'background-color 150ms, color 150ms, box-shadow 150ms',
  '&:hover': { color: 'text.primary' },
});
